import { render, staticRenderFns } from "./BlogDrawerItem.vue?vue&type=template&id=5af7c3c2&scoped=true&"
import script from "./BlogDrawerItem.vue?vue&type=script&lang=js&"
export * from "./BlogDrawerItem.vue?vue&type=script&lang=js&"
import style0 from "./BlogDrawerItem.vue?vue&type=style&index=0&id=5af7c3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7c3c2",
  null
  
)

export default component.exports